import { Toast } from 'vant'

const isNumber = (val) => {
  var regPos = /^\d+(\.\d+)?$/ // 非负浮点数
  var regNeg = /^(-(([0-9]+\.[0-9]*[1-9][0-9]*)|([0-9]*[1-9][0-9]*\.[0-9]+)|([0-9]*[1-9][0-9]*)))$/ // 负浮点数
  if (regPos.test(val) || regNeg.test(val)) {
    return true
  } else {
    return false
  }
}
const getValueIndex = (arr, value) => {
  for (let i = 0; i < arr.length; i++) {
    if (arr[i] === value) {
      return i
    }
  }
  return -1
}
const includes = (arr1, arr2) => {
  return arr2.every((value) => {
    return inArray(value, arr1)
  })
}
export const inArray = (val, arr) => {
  for (let i = 0; i < arr.length; i++) {
    if (arr[i] === val) {
      return true
    }
  }
  return false
}
/**
 * 判断设备类型
 * @returns {boolean} android：安卓，false：ios
 */
export const deviceType = () => {
  let u = navigator.userAgent
  // let app = navigator.appVersion;
  let android = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1 // android终端或者uc浏览器
  // let ios = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
  return android === true
}
/**
 * 格式化时间
 * @param time 时间戳
 * @param fmt
 * @returns {*}
 */
export const formatDate = (time, fmt) => {
  if (time) {
    let date = new Date(time)
    if (/(y+)/.test(fmt)) {
      fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length))
    }
    let o = {
      'M+': date.getMonth() + 1,
      'd+': date.getDate(),
      'h+': date.getHours(),
      'm+': date.getMinutes(),
      's+': date.getSeconds()
    }
    for (let k in o) {
      if (new RegExp(`(${k})`).test(fmt)) {
        let str = o[k] + ''
        fmt = fmt.replace(RegExp.$1, RegExp.$1.length === 1 ? str : padLeftZero(str))
      }
    }
    return fmt
  }
  return time
}

function padLeftZero(str) {
  return ('00' + str).substr(str.length)
}

export const verdictEmpty = (msg) => {
  if (typeof msg === 'number') {
    msg = msg.toString()
  }
  return msg == null || msg === undefined || Object.keys(msg).length === 0
}

export const showLoading = (message = '', duration = 0) => {
  Toast.loading({
    message,
    forbidClick: true,
    duration
  })
}

export default {
  isNumber: isNumber,
  getValueIndex: getValueIndex,
  includes: includes,
  deviceType: deviceType,
  formatDate: formatDate,
  verdictEmpty: verdictEmpty,
  inArray: inArray,
  showLoading: showLoading
}
